import * as React from "react";

function SvgBeamer(props, ref) {
  return (
    <svg
      height="1em"
      viewBox="0 0 750 800"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path d="M53.467 682.996c-21.145 0-41.191-12.453-49.739-33.083-11.303-27.265 1.785-58.478 29.241-69.707l628.452-257.034c27.456-11.213 58.896 1.786 70.205 29.059 11.299 27.284-1.797 58.499-29.252 69.722L73.927 678.969c-6.698 2.723-13.641 4.027-20.46 4.027zM53.467 479.393c-21.145 0-41.191-12.453-49.739-33.083-11.303-27.281 1.785-58.497 29.241-69.729l628.452-257.012c27.456-11.229 58.896 1.781 70.205 29.05 11.299 27.273-1.797 58.486-29.252 69.72L73.927 475.35a53.777 53.777 0 01-20.46 4.043zM53.467 269.101c-21.224 0-41.345-12.562-49.829-33.3-11.182-27.323 2.045-58.473 29.559-69.59L418.709 10.507c27.503-11.107 58.87 2.03 70.062 29.361 11.188 27.32-2.045 58.48-29.559 69.584L73.699 265.156a53.88 53.88 0 01-20.232 3.945zM295.442 793.152c-21.244 0-41.346-12.57-49.829-33.311-11.192-27.312 2.046-58.462 29.549-69.591l385.513-155.688c27.514-11.107 58.885 2.024 70.061 29.363 11.193 27.308-2.039 58.472-29.549 69.579L315.67 789.199a53.808 53.808 0 01-20.228 3.953z" />
    </svg>
  );
}

export default React.forwardRef(SvgBeamer);
